import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppLayout } from '@/layouts/AppLayout'
import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/_app')({
  beforeLoad: () => {
    const { accessToken, activeBusiness } = useAuthStore.getState()
    if (!accessToken) throw redirect({ to: '/login' })
    if (activeBusiness?.portal_only) throw redirect({ to: '/employee' })
  },
  component: AppLayout,
})
